import { BOGO_GIFT_STATES } from '@mc/bogo'

export const STATES = {
  INITIALIZER: 'initializer',
  ASK_EMAIL_CAPTURE: 'ask_email_capture',
  FETCH_LOGGED_IN_USER: 'fetch_logged_in_user',
  CHOOSE_MEMBERSHIP: 'choose_membership',
  CHECK_IS_LOGGED_IN: 'check_is_logged_in',
  CHOOSE_PAYMENT_METHOD: 'choose_payment_method',
  EMAIL_CAPTURE: 'email_capture',
  MULTI_GIFT_PICKER: 'multi_gift_picker',
  PAYMENT: 'payment',
  SETUP_ACCOUNT: 'setup_account',
  // CE-3314: Email Correction Flow
  EMAIL_CORRECTION: 'email_correction',
  EMAIL_CORRECTION_VERIFICATION_SENT: 'email_correction_verification_sent',
  CREDIT_CARD: 'credit_card',
  PAYPAL: 'paypal',
  APPLE_PAY: 'apple_pay',
  REFERRAL_SURVEY: 'referral_survey',
  REFERRAL_SURVEY_MAIN: 'referral_survey_main',
  REFERRAL_SURVEY_AUDIO: 'referral_survey_audio',
  BOGO: 'bogo_gift',
  BOGO_POST: 'bogo_gift_post',
  GUEST_PASS: 'guest_pass',
  SEND_GUEST_PASS: 'send_guest_pass',
  SKIP_GUEST_PASS: 'skip_guest_pass',
  GUEST_PASS_SUCCESS: 'guest_pass_success',
  FINISH_CHECKOUT: 'finish_checkout',
  ABORT_CHECKOUT: 'abort_checkout',
  // prcng-338_v1
  INTRO_PRICING_UPGRADE: 'intro_pricing_upgrade',
  INTRO_PRICING_UPGRADE_OFFER: 'intro_pricing_upgrade_offer',
  INTRO_PRICING_UPGRADE_COMPLETED: 'intro_pricing_upgrade_completed',
  INTRO_PRICING_UPGRADE_EXIT: 'intro_pricing_upgrade_exit',
  // prcng-451_v1
  GIFT_ADD_ON_V3: 'gift_add_on_v3',
  GIFT_ADD_ON_V3_PURCHASE: 'gift_add_on_v3_purchase',
  GIFT_ADD_ON_V3_THANKS: 'gift_add_on_v3_thanks',
  GIFT_ADD_ON_V3_ERROR: 'gift_add_on_v3_error',
  LEARNING_TOOLKIT_ADD_ON_V3: 'learning_toolkit_add_on_v3',
  LEARNING_TOOLKIT_ADD_ON_V3_MAIN: 'learning_toolkit_add_on_v3_main',
  LEARNING_TOOLKIT_ADD_ON_V3_LIST: 'learning_toolkit_add_on_v3_main_list',
  LEARNING_TOOLKIT_ADD_ON_V3_AI: 'learning_toolkit_add_on_v3_main_ai',
  LEARNING_TOOLKIT_ADD_ON_V3_RECIPE_CARDS:
    'learning_toolkit_add_on_v3_main_recipe_cards',
  LEARNING_TOOLKIT_ADD_ON_V3_BOOKMARKS:
    'learning_toolkit_add_on_v3_main_bookmarks',
  LEARNING_TOOLKIT_ADD_ON_V3_NOTES: 'learning_toolkit_add_on_v3_main_notes',
  LEARNING_TOOLKIT_ADD_ON_V3_CLASS_GUIDES:
    'learning_toolkit_add_on_v2_main_class_guides',
  LEARNING_TOOLKIT_ADD_ON_V3_THANKS: 'learning_toolkit_add_on_v3_main_thanks',
  LEARNING_TOOLKIT_ADD_ON_V3_CONGRATS:
    'learning_toolkit_add_on_v3_main_congrats',
  LEARNING_TOOLKIT_ADD_ON_V3_ERROR: 'learning_toolkit_add_on_v3_error',
  ON_CALL_ADD_ON: 'on_call_add_on',
  ON_CALL_ADD_ON_PURCHASE: 'on_call_add_on_purchase',
  ON_CALL_ADD_ON_THANKS: 'on_call_add_on_thanks',
  ON_CALL_ADD_ON_ERROR: 'on_call_add_on_error',
  ON_CALL_ADD_ON_PURCHASE_LIST: 'on_call_add_on_purchase_list',
  ON_CALL_ADD_ON_PURCHASE_GUIDANCE: 'on_call_add_on_purchase_guidance',
  ON_CALL_ADD_ON_PURCHASE_ROLEPLAYS: 'on_call_add_on_purchase_roleplays',
  ON_CALL_ADD_ON_PURCHASE_FEEDBACK: 'on_call_add_on_purchase_feedback',
  // prcng-813_v2
  CERTS_POST_PURCHASE: 'certs_post_purchase',
  CERTS_POST_PURCHASE_MAIN: 'certs_post_purchase_main',
  // prcng-1086_v1 — MAIN splits so each arm's shell gets its own theme
  CERTS_POST_PURCHASE_MAIN_DEFAULT: 'certs_post_purchase_main_default',
  CERTS_POST_PURCHASE_MAIN_REDESIGN: 'certs_post_purchase_main_redesign',
  CERTS_POST_PURCHASE_THANKS: 'certs_post_purchase_thanks',
  CERTS_POST_PURCHASE_ERROR: 'certs_post_purchase_error',
} as const

export const GUEST_PASS_SUBSTATES = {
  SEND: `${STATES.GUEST_PASS}.${STATES.SEND_GUEST_PASS}`,
  SKIP: `${STATES.GUEST_PASS}.${STATES.SKIP_GUEST_PASS}`,
  SENT: `${STATES.GUEST_PASS}.${STATES.GUEST_PASS_SUCCESS}`,
}

export const PAYMENT_DETAILS_SUBSTATES = {
  CREDIT_CARD: `${STATES.PAYMENT}.${STATES.CREDIT_CARD}`,
  PAYPAL: `${STATES.PAYMENT}.${STATES.PAYPAL}`,
  APPLE_PAY: `${STATES.PAYMENT}.${STATES.APPLE_PAY}`,
}

export const EMAIL_CAPTURE_SUBSTATES = {
  ASK_EMAIL_CAPTURE: `${STATES.EMAIL_CAPTURE}.${STATES.ASK_EMAIL_CAPTURE}`,
  CHECK_IS_LOGGED_IN: `${STATES.EMAIL_CAPTURE}.${STATES.CHECK_IS_LOGGED_IN}`,
}

export const REFERRAL_SURVEY_SUBSTATES = {
  MAIN: `${STATES.REFERRAL_SURVEY}.${STATES.REFERRAL_SURVEY_MAIN}`,
  AUDIO: `${STATES.REFERRAL_SURVEY}.${STATES.REFERRAL_SURVEY_AUDIO}`,
}

export const BOGO_GIFT_SUBSTATES = {
  PROMPT: `${STATES.BOGO}.${BOGO_GIFT_STATES.PROMPT}`,
  SEND: `${STATES.BOGO}.${BOGO_GIFT_STATES.SEND}`,
  SENT: `${STATES.BOGO}.${BOGO_GIFT_STATES.SENT}`,
}

export const TRANSITIONS = {
  MEMBERSHIP_CHOSEN: 'membership_chosen',
  EMAIL_CAPTURED: 'email_captured',
  EMAIL_UPDATED: 'email_updated',
  STRIPE_CHOSEN: 'stripe_chosen',
  BRAINTREE_CHOSEN: 'braintree_chosen',
  APPLE_PAY_CHOSEN: 'apple_pay_chosen',
  PURCHASE_COMPLETED: 'purchase_completed',
  CHANGE_MEMBERSHIP: 'change_membership',
  GO_TO_PREVIOUS_STEP: 'go_to_previous_step',
  ACCOUNT_SET: 'account_set',
  // CE-3314: Email Correction Flow transitions
  EMAIL_CORRECTION_NEEDED: 'email_correction_needed',
  EMAIL_CORRECTION_REQUESTED: 'email_correction_requested',
  EMAIL_CORRECTION_CANCELED: 'email_correction_canceled',
  EMAIL_CORRECTION_NEEDED_AGAIN: 'email_correction_needed_again',
  REFERRAL_SURVEY_SENT: 'referral_survey_sent',
  REFERRAL_SURVEY_AUDIO_SENT: 'referral_survey_audio_sent',
  GUEST_PASS_SENT: 'guest_pass_sent',
  GUEST_PASS_SKIPPED: 'guest_pass_skipped',
  GUEST_PASS_STEP_COMPLETED: 'guest_pass_step_completed',
  // prcng-451_v1
  GIFT_ADD_ON_PURCHASE_COMPLETED: 'gift_add_on_purchase_completed',
  GIFT_ADD_ON_CONTINUE: 'gift_add_on_continue',
  LEARNING_TOOLKIT_ADD_ON_CONTINUE: 'learning_toolkit_add_on_continue',
  LEARNING_TOOLKIT_ADD_ON_CANCEL: 'learning_toolkit_add_on_cancel',
  LEARNING_TOOLKIT_ADD_ON_NEXT: 'learning_toolkit_add_on_next',
  LEARNING_TOOLKIT_ADD_ON_BACK: 'learning_toolkit_add_on_back',
  // prcng-338_v1 & prcng-451_v1 & prcng-813_v2
  CONTINUE: 'continue',
  CANCEL: 'cancel',
  EXPAND: 'expand',
  BACK: 'back',
  ADD_ON_PURCHASE_ERROR: 'add_on_purchase_error',
}

export const STEPS = {
  MEMBERSHIP: 1,
  ACCOUNT: 2,
  PAYMENT: 3,
} as const
